import { useEffect, useMemo, useState } from 'react'
import { ReactFlow, Background, Controls, type Node, type Edge } from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import { C4Node } from './C4Node'
import { elkLayout, type C4NodeData } from './elkLayout'
import type { GraphNodeDto, GraphEdgeDto } from '../hooks/useGraph'

interface GraphCanvasProps {
  nodes: GraphNodeDto[]
  edges: GraphEdgeDto[]
  onNodeClick: (key: string) => void
}

/** React Flow canvas with ELK hierarchical layout. Clicking a node drills in. */
export function GraphCanvas({ nodes, edges, onNodeClick }: GraphCanvasProps) {
  const [laidOut, setLaidOut] = useState<{ nodes: Node<C4NodeData>[]; edges: Edge[] }>({ nodes: [], edges: [] })
  const nodeTypes = useMemo(() => ({ c4: C4Node }), [])

  useEffect(() => {
    let active = true
    void elkLayout(nodes, edges).then((result) => {
      if (active) setLaidOut(result)
    })
    return () => {
      active = false
    }
  }, [nodes, edges])

  return (
    <div className="h-[calc(100vh-12rem)] w-full rounded border border-neutral-200 dark:border-neutral-800">
      <ReactFlow
        nodes={laidOut.nodes}
        edges={laidOut.edges}
        nodeTypes={nodeTypes}
        onNodeClick={(_, node) => onNodeClick(node.id)}
        fitView
        proOptions={{ hideAttribution: true }}
      >
        <Background />
        <Controls />
      </ReactFlow>
    </div>
  )
}
